import React from 'react'
import ReactDOM from 'react-dom'

import { IntranetTools } from './IntranetTools'
import reportWebVitals from './reportWebVitals'

import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <IntranetTools />
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()
